<template>
  <div>

    <mytable
      :tableColums='tableColums_getSysKeyList'
      api='getSysKeyList'
      updateapi='updateSysKey'
      :height="H-122" >
      <div slot="skValue" slot-scope="{row}" v-html="row.skValue" style="max-height: 20vh;overflow: hidden;max-width: 99%;"></div>
    </mytable>

    <myform view.updateSysKey ></myform>

    <!-- window.Math.abs( window.innerWidth - superEditor.getContainer().clientWidth ) <= 10 -->
    <myform view.tinymce='富文本编辑器 - 全屏: 双击或点击最后一个按钮#el-icon-circle-check#保存'
      id="PromotionManage"
      width='85%' top='50px'
      @closed='row = null'
      @opened="$event.title = row.skRemark + ' - 全屏: 双击或点击最后一个按钮'"
      @close='arguments[1] && (arguments[0].actived="")'
      @show='boolean=true,superEditor && superEditor.show( window.sleep(400,v=>superEditor.focus()) )'
      @confirm='superEditorUpload'
      >
      <!-- <div v-if='boolean'>{{ window.alert(5555) }}</div> -->
      <div v-if='boolean' >
        <tinymce v-model='string' xreadonly v-s.height='H-180' id='tinymce' ></tinymce>
      </div>
     
    </myform>

  </div>
</template>

<script>
export default {
  data() {
    return {
      userId: null,

      tableColums_getSysKeyList: {
        $selection: false,

        skRemark: ['描述',200,],

        skValue: '值',

        skValueTwo: ['值two',100,],

        $operation: this.updateSysKey && [
          '操作', 140,

          this.updateSysKey && `@text: 编辑#warn
           @click:
              ($row.skId == 1|| $row.skId == 5)
              ? $form("updateSysKey",$row)
              : ( $form('tinymce'), string = ($this.row=$row).skValue + '' )
          `,
        ],
      },

    };
  },

  watch: {
    superEditor(superEditor) {
      superEditor.focus();
    },
  },

  methods: {

    async superEditorUpload(submit,Myformdata) {
      // return console.error(submit, Myformdata, arguments);
      // return console.error(this.string, this.row.skValue, this.row);
      if( this.string !== this.row.skValue && this.superEditor ) {
        var html = await this.superEditor.upload(document.body); // this.$refs.reward.$el.firstElementChild
        //console.log(html);
        if( html !== html ) return;
        await sleep(20);
        this.updateSysKey('正在更新',{
          ...this.row,
          skValue: html
        }).result(res=>{
          // console.error(res);
          res && ( this.getSysKeyList(), this.$form('tinymce', false) );
        });
        return;
      };

      this.$form('tinymce', false);
    },

  },

  created() {
    // console.warn('#SysKey.vue');
    this.getSysKeyList();
  },
};
</script>

<style xscoped>
  #PromotionManage > .el-dialog__wrapper, #PromotionManage > .el-dialog__wrapper > [fullscreen] {
    overflow: hidden!important;
  }
  #PromotionManage [fullscreen] #tinymce {
    height: 90vh!important;
  }
  #PromotionManage .el-dialog__body {
    padding-top: 7px!important;
    padding-bottom: 0!important;
  }
  #PromotionManage .el-dialog__footer {
    padding: 0px 27px 25px!important;
  }
  #PromotionManage .el-button {
    position: absolute;
    top: 15px;
    right: 60px;
    border-radius: 50px;
    z-index: 777;
  }
</style>



// WEBPACK FOOTER //
// src/views/unipue/#SysKey.vue